module.exports = __webpack_public_path__ + "static/media/3DPPA39.648360e3.jpg";